import { useTaxPrice, useTotalIncludeTax, useTotalPrice } from './hooks'

import Client from './Client'
import Footer from './Footer'
import Header from './Header'
import LineHead from './LineHead'
import LineItem from './LineItem'
import React from 'react'
import ReactToPrint from 'react-to-print'
import TaxItem from './TaxItem'
import TotalRow from './TotalRow'
import TotalTax from './TotalTax'

const PdfGenerator = ({ invoice }) => {
  const {
    date,
    dueDate,
    invoiceId,
    clientId,
    clientAddress,
    items,
    tax,
    currency,
    footerId
  } = invoice
  const componentRef = React.useRef()
  const totalPrice = useTotalPrice(items)
  const allTax = useTaxPrice(tax, totalPrice)
  const totalIncludeTax = useTotalIncludeTax(allTax, totalPrice)

  return (
    <>
      <div className="justify-center items-center mb-3">
        <ReactToPrint
          trigger={() => <button>Print this out!</button>}
          content={() => componentRef.current}
        />
      </div>

      <div
        className="container h-full bg-white shadow-md p-4 relative"
        ref={componentRef}>
        <Header
          invoiceDate={date}
          invoiceDueDate={dueDate}
          customerId={clientId}
          invoiceId={invoiceId}
        />
        <Client clientAddress={clientAddress} />

        <LineHead />
        {items &&
          items.map((lineItem, index) => {
            return (
              <LineItem
                lineItem={lineItem}
                key={`item-${index}`}
                currency={currency}
              />
            )
          })}

        <TotalRow total={totalPrice} currency={currency} />

        {allTax &&
          Object.keys(allTax).map((name, index) => {
            return (
              <TaxItem
                name={name}
                amount={allTax[name]}
                key={`titem-${index}`}
                currency={currency}
              />
            )
          })}

        <TotalTax total={totalIncludeTax} currency={currency} />
        <Footer footerId={footerId} />
      </div>
    </>
  )
}

export default PdfGenerator
